import CompaniesList from './CompaniesList'
export default CompaniesList
